import React, {useState} from 'react'
import Login from './login'
import LoginLogo from './loginLogo'
import Signup from './Signup'
import {AppState} from '../context/AppProvider'


const Home = () => {

    const {
        isLoggedIn,
        view, 
        setView,
        room,
        setRoom,
        user,
        setUser,
        meetings,
        setMeetings,
        currentMeeting,
        setCurrentMeeting,
        notifications,
        setNotifications,
    
        setIsLoading } = AppState()
        const [ showSignup, setShowSignup ] = useState(false)

        const toggleSignup = () => {
                setView('signup')
                setShowSignup(!showSignup)
                // window.location.href = '/signup'
        }
  return (
    <>
     <div className={'blink'} style={{zIndex:'100'}}>
                    <button
                        type="submit"
                        //!add blink
                        // className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        className="signup-button button-blue"
                        id="signup-button"
                        style={{padding:'.5rem', marginTop:'0.5rem'}}
                        onClick={toggleSignup}
                        //  isLoading= {loading}   
                    >{!showSignup? 'signup':'back to login'}
                        {/* {loading? "signing":"sign"}up */}
                    </button>
                  </div>
         <div className="body-interf-2 center color-grad-blue-border" id="mainframe">&nbsp;
           
            <div id='top-z'>
              <LoginLogo />
              <div style={{display:'flex', flexDirection: 'column',maxHeight:'260px', width: '100%', overflowX:'hidden', overflowY:'scroll', padding:'.5rem'}}>
                {!showSignup ?<Login 
                  view={view} 
                  setView={setView}
                  />:<Signup
                  view={view} 
                  setView={setView}
                  />}

              </div>
            </div>
                            {/* {frameContent} */}
            <div className="rot-bg center">
              <div className="sphere-wrap center"> 
                <div className="login-top sun">
                  <img src="./images/Sun_01.png" alt ="sun"/>
                </div>
                <div className="login-bottom moon">
                  
                    <img src="./images/Moon_01.png" alt ="moon"/>
                  {/* <h1>moon</h1> */}
                </div>
              </div>
              <div className="cloud-div">  
                <img src="./images/Cloud_01.png" alt ="cloud"/>
              </div>
            </div>
            
            </div>
           
    </>
  )
}

export default Home